import PubSub from "underpub-js";
import URI from "urijs";
import Cookies from 'js-cookie';
import ConsentedCookie from '../../../../scripts/classes/ConsentedCookie';
import jstree from 'jstree';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

var DirectoryTwo = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-DirectoryTwo',
	};

	$.extend(true, this.options, options);

};

DirectoryTwo.prototype.init = function() {

	var self = this;

	// dom elements
	this.$keywordSearchInput = this.options.$el.find(`.${self.options.baseClass}__keywordSearchWrapper--desktop .${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$keywordSearchButton = this.options.$el.find(`.${self.options.baseClass}__keywordSearch__keywordSearchButton`);
	this.$mobileKeywordSearchInput = this.options.$el.find(`.${self.options.baseClass}__keywordSearchWrapper--mobile .${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$filterWrappers = this.options.$el.find(`.${self.options.baseClass}__dropdownFilterWrapper`);
	this.$expertiseFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--expertise .${self.options.baseClass}__dropdownFilter__filter`);
	this.$locationFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--location .${self.options.baseClass}__dropdownFilter__filter`);
	this.$leadershipFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--leadership .${self.options.baseClass}__dropdownFilter__filter`);
	this.$dropdownFilterHeadings = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter__heading`);
	this.$filterButton = this.options.$el.find(`.${self.options.baseClass}__submitFiltersButton button`);
	this.$filterCollapseTrigger = this.options.$el.find(`.${self.options.baseClass}__filterCollapseTrigger`);
	this.$filterCollapseWrapper = this.options.$el.find(`.${self.options.baseClass}__filterCollapseWrapper`);
	this.$filterCollapseIndicator = this.$filterCollapseTrigger.find(`.${self.options.baseClass}__filterCollapseTrigger__openCloseIndicator span`).eq(0);
	this.$lastNameFilters = this.options.$el.find(`.${self.options.baseClass}__lastNameFilters__filters__filter`);
	this.$heightAdjustWrapper = this.options.$el.find(`.${self.options.baseClass}__resultsPaginationWrapper`);
	this.$paginationWrapper = this.options.$el.find(`.${self.options.baseClass}__pagination`);
	this.$placeholdersContainer = this.options.$el.find(`.${self.options.baseClass}__results--placeholders`);
	this.$resultsContainer = this.options.$el.find(`.${self.options.baseClass}__results--container`);
	this.$noResultsContainer = this.options.$el.find(`.${self.options.baseClass}__results--noResults`);
	this.$personResultTemplate = this.options.$el.find(`.${self.options.baseClass}__resultWrapper--resultTemplate`);
	this.$filtersLoader = this.options.$el.find(`.${self.options.baseClass}__filtersLoader`);
	this.$clearFiltersButton = this.options.$el.find(`.${self.options.baseClass}__clearFiltersButton`);

	// state variables
	this.activeLastNameFilters = [];
	this.loadStartTime = new Date().getTime() / 1000;

	// these variables will hold the most recently submitted search/filters, and will be used
	// by the pagination links
	this.submittedQuery = '';
	this.submittedExpertiseFilters = [];
	this.submittedLocationFilters = [];
	this.submittedLeadershipFilters = [];
	this.submittedLastNameFilters = [];

	this.initFilters();
	this.initPagination();

	let searchParams = new URLSearchParams(window.location.search);

	if (searchParams.has('expertise')) {

		// expertise URL param is set, so update the filter before submitting
		let expertiseId = searchParams.get('expertise');
	
		this.$expertiseFilter.jstree('open_all');
		let expertiseNode = $(`[data-id="${expertiseId}"]`); // get the node by ID
		this.$expertiseFilter.jstree().select_node(expertiseNode, true);
		this.$expertiseFilter.jstree('close_all');

		// remove the URL parameter so that if a person is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL( currentUrlWithoutParams );
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

	}
	else {

		let savedQuery = Cookies.get('directoryQuery');
		let expertiseToSelect = Cookies.get('directoryExpertise');
		let locationToSelect = Cookies.get('directoryLocation');
		let leadershipToSelect = Cookies.get('directoryLeadership');

		if (savedQuery) {
			this.$keywordSearchInput.val(savedQuery);
			this.$mobileKeywordSearchInput.val(savedQuery);
		}

		if (expertiseToSelect) {

			let expertiseIds = expertiseToSelect.split('|');

			this.$expertiseFilter.jstree('open_all');

			for (let i = 0; i < expertiseIds.length; i++) {
				
				let expertiseId = expertiseIds[i];
	
				let expertiseNode = $(`[data-id="${expertiseId}"]`); // get the node by ID
				this.$expertiseFilter.jstree().select_node(expertiseNode, true);

			}

			this.$expertiseFilter.jstree('close_all');

		}

		if (locationToSelect) {

			let locationIds = locationToSelect.split('|');

			this.$locationFilter.jstree('open_all');

			for (let i = 0; i < locationIds.length; i++) {
				
				let locationId = locationIds[i];
				let locationNode = $(`#${locationId}`); // get the node by ID

				this.$locationFilter.jstree().select_node(locationNode, true);

			}

			this.$locationFilter.jstree('close_all');

		}

		if (leadershipToSelect) {

			let leadershipIds = leadershipToSelect.split('|');

			this.$leadershipFilter.jstree('open_all');

			for (let i = 0; i < leadershipIds.length; i++) {
				
				let leadershipId = leadershipIds[i];
	
				let leadershipNode = $(`[data-id="${leadershipId}"]`); // get the node by ID
				this.$leadershipFilter.jstree().select_node(leadershipNode, true);

			}

			this.$leadershipFilter.jstree('close_all');

		}

	}

	this.submitFilters();
	
};

DirectoryTwo.prototype.initFilters = function() {

	var self = this;

	this.$expertiseFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			},
			"loaded_state": true
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	this.$expertiseFilter.jstree('hide_checkboxes');

	this.$locationFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox", "sort" ]
	});

	this.$locationFilter.jstree('hide_checkboxes');

	this.$leadershipFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	this.$leadershipFilter.jstree('hide_checkboxes');

	// when a dropdown filter heading is clicked
	this.$dropdownFilterHeadings.on('click', function() {

		let $dropdownFilter = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);

		if ($dropdownFilter.hasClass(`${self.options.baseClass}__dropdownFilter--active`))
		{
			self.closeDropdownFilter($dropdownFilter);
		}
		else
		{
			self.openDropdownFilter($dropdownFilter);
		}
		
	});

	this.filterCollapseTimeline = gsap.timeline({
		defaults: {
			duration: 0.3
		}
	})
	.to(self.$filterCollapseIndicator, {
		rotation: 0,
		duration: 0.35,
		ease: "power1.inOut"
	}, 0)
	.to(self.$filterCollapseWrapper, {
		height: 'auto',
	}, 0).reverse();

	// when the filter show/hide button is clicked on mobile
	this.$filterCollapseTrigger.on('click', function() {
		self.filterCollapseTimeline.reversed(!self.filterCollapseTimeline.reversed());
	});

	// when the keyword search button is clicked
	this.$keywordSearchButton.on('click', function() {
		// set our loading state
		self.loading();
		self.submitFilters();
	});

	// when the enter key is pressed and the text search box has focus
	$(document).on('keypress',function(e) {
		if(e.which == 13) {
			if (self.$keywordSearchInput.is(":focus") || self.$mobileKeywordSearchInput.is(":focus")) {
				// set our loading state
				self.loading();
				self.submitFilters();
			}
		}
	});

	// make sure our mobile/desktop keyword search fields have the same value
	this.options.$el.find(`.${self.options.baseClass}__keywordSearch input`).on('input', function() {
		var value = $(this).val();
		self.options.$el.find(`.${self.options.baseClass}__keywordSearch input`).val(value);
	});

	// last name filters on click
	this.$lastNameFilters.on('click', function() {

		let activeClass = `${self.options.baseClass}__lastNameFilters__filters__filter--active`;
		let letter = $(this).data('filterLetter');

		self.options.$el.find('.'+activeClass).removeClass(activeClass);
		$(this).addClass(activeClass);
		self.activeLastNameFilters = [letter];

		self.loading();
		self.submitFilters();

		// if ($(this).hasClass(activeClass)) {
		// 	$(this).removeClass(activeClass);
		// 	self.activeLastNameFilters.splice(self.activeLastNameFilters.indexOf(letter), 1); // remove letter
		// }
		// else {
		// 	$(this).addClass(activeClass);
		// 	self.activeLastNameFilters.push(letter);
		// }

	});

	// when the clear filters button is clicked
	this.$clearFiltersButton.on('click', function() {
		self.clearAllFilters();
		// set our loading state
		self.loading();
		self.submitFilters();
	});

	// when a dropdown filter is changed
	this.$expertiseFilter.on('changed.jstree', function(e, data) {

		let $filterParent = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);
		let selectedClass = `${self.options.baseClass}__dropdownFilter--selected`;

		// set a class that indicates if this filter is active or not
		if (data.selected.length || data.node) {
			$filterParent.addClass(selectedClass);
		}
		else {
			$filterParent.removeClass(selectedClass);
		}

		if (data.action == 'ready' || data.action == 'deselect_all') {
			return;
		}

		// only allow one selection

		self.$expertiseFilter.jstree().deselect_all(true);

		self.$expertiseFilter.jstree().select_node(data.node, true);

		// update our results
		self.loading();
		self.submitFilters();

	});

	this.$locationFilter.on('changed.jstree', function(e, data) {

		let $filterParent = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);
		let selectedClass = `${self.options.baseClass}__dropdownFilter--selected`;

		if (data.selected.length || data.node) {
			$filterParent.addClass(selectedClass);
		}
		else {
			$filterParent.removeClass(selectedClass);
		}

		if (data.action == 'ready' || data.action == 'deselect_all') {
			return;
		}

		// only allow one selection, so deselect all other options
		self.$locationFilter.jstree().deselect_all(true);

		self.$locationFilter.jstree().select_node(data.node, true);

		// update our results
		self.loading();
		self.submitFilters();

	});

	this.$leadershipFilter.on('changed.jstree', function(e, data) {

		let $filterParent = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);
		let selectedClass = `${self.options.baseClass}__dropdownFilter--selected`;

		if (data.selected.length || data.node) {
			$filterParent.addClass(selectedClass);
		}
		else {
			$filterParent.removeClass(selectedClass);
		}

		if (data.action == 'ready' || data.action == 'deselect_all') {
			return;
		}

		// only allow one selection, so deselect all other options
		self.$leadershipFilter.jstree().deselect_all(true);

		self.$leadershipFilter.jstree().select_node(data.node, true);

		// update our results
		self.loading();
		self.submitFilters();

	});

	// when clicking outside the filters, close them
	$(`body`).on('click', function() {
		
		if(window.Breakpoint.value != "xsmall" && window.Breakpoint.value != "small"){
			self.closeAllDropdownFilters();
		}

	});

	// when clicking a filter, don't close the filters
	this.$filterWrappers.on('click', function(e) {
		e.stopPropagation();
	});
	
};

DirectoryTwo.prototype.initPagination = function() {

	var self = this;

	this.options.$el.on('click', `.${self.options.baseClass}__pagination__link`, function() {
		self.goToPage( $(this).data('page') );
	});

};

DirectoryTwo.prototype.openDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.addClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 'auto',
		duration: 0.5,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

DirectoryTwo.prototype.closeAllDropdownFilters = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__dropdownFilter`).each(function() {

		self.closeDropdownFilter($(this));

	});

};

DirectoryTwo.prototype.closeDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.removeClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 0,
		duration: 0.35,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

DirectoryTwo.prototype.clearAllFilters = function() {

	var self = this;

	this.$expertiseFilter.jstree().deselect_all();
	this.$locationFilter.jstree().deselect_all();
	this.$leadershipFilter.jstree().deselect_all();

	this.$expertiseFilter.jstree('close_all');
	this.$locationFilter.jstree('close_all');
	this.$leadershipFilter.jstree('close_all');

	this.$keywordSearchInput.val('');
	this.$mobileKeywordSearchInput.val('');

	let activeLastNameFilterClass = `${self.options.baseClass}__lastNameFilters__filters__filter--active`;
	$('.' + activeLastNameFilterClass).removeClass(activeLastNameFilterClass);
	this.activeLastNameFilters = [];

};

// gets our filter values and passes them to updatePeopleResults
DirectoryTwo.prototype.submitFilters = function() {

	var self = this;

	var query = this.$keywordSearchInput.val();

	ConsentedCookie.set('directoryQuery', query, 'functional');

	// expertise filters
	var selectedExpertiseFilters = this.$expertiseFilter.jstree('get_bottom_checked');
	var selectedExpertiseIds = [];

	for (let i = 0; i < selectedExpertiseFilters.length; i++) {
		let $node = self.$expertiseFilter.jstree('get_node', selectedExpertiseFilters[i]);
		selectedExpertiseIds = [...new Set([...selectedExpertiseIds,...[$node.data.id.toString()] ])]; // filter out duplicates
	}

	// update expertise filters cookie
	ConsentedCookie.set('directoryExpertise', selectedExpertiseIds.join('|'), 'functional');

	// location filters
	var selectedLocationFilters = this.$locationFilter.jstree('get_bottom_checked');
	var selectedLocationIds = [];
	var selectedLocationFilterIds = [];

	for (let i = 0; i < selectedLocationFilters.length; i++) {
		let $node = self.$locationFilter.jstree('get_node', selectedLocationFilters[i]);
		selectedLocationIds = [...new Set([...selectedLocationIds,...$node.data.branches])]; // filter out duplicates
		selectedLocationFilterIds.push($node.id); // filter out duplicates
	}

	// update location filters cookie
	ConsentedCookie.set('directoryLocation', selectedLocationFilterIds.join('|'), 'functional');

	// leadership filters
	var selectedLeadershipFilters = this.$leadershipFilter.jstree('get_bottom_checked');
	var selectedLeadershipIds = [];

	for (let i = 0; i < selectedLeadershipFilters.length; i++) {
		let $node = self.$leadershipFilter.jstree('get_node', selectedLeadershipFilters[i]);
		selectedLeadershipIds = [...new Set([...selectedLeadershipIds,...[$node.data.id.toString()] ])]; // filter out duplicates
	}

	// update leadership filters cookie
	ConsentedCookie.set('directoryLeadership', selectedLeadershipIds.join('|'), 'functional');

	this.updatePeopleResults(query, selectedExpertiseIds, selectedLocationIds, selectedLeadershipIds, self.activeLastNameFilters);

};

// this function takes values for all filters and updates the people results
DirectoryTwo.prototype.updatePeopleResults = function(query, expertiseFilters, locationFilters, leadershipFilters, lastNameFilters, pageNumber) {

	var self = this;

	this.submittedQuery = query;
	this.submittedExpertiseFilters = expertiseFilters;
	this.submittedLocationFilters = locationFilters;
	this.submittedLeadershipFilters = leadershipFilters;
	this.submittedLastNameFilters = lastNameFilters;

	var ajaxData = {
		query: query,
		expertiseFilters: JSON.stringify(expertiseFilters),
		locationFilters: JSON.stringify(locationFilters),
		leadershipFilters: JSON.stringify(leadershipFilters),
		lastNameFilters: JSON.stringify(lastNameFilters),
		pageNumber: pageNumber,
	};

	$.ajax({

		contentType: "application/json",
		url: '/actions/held-helpers-module/default/get-filtered-people',

		data: ajaxData,

		success: function(data) {
			console.log('AJAX success: people data');
			console.log(data);
			self.doneLoading(data);
		},

		error: function(data) {
			console.log('AJAX error');
			console.log(data);
		}

	});

};

DirectoryTwo.prototype.goToPage = function(pageNumber) {

	var self = this;

	// set our loading state
	this.loading();

	this.updatePeopleResults(this.submittedQuery, this.submittedExpertiseFilters, this.submittedLocationFilters, this.submittedLeadershipFilters, this.submittedLastNameFilters, pageNumber);

};

DirectoryTwo.prototype.loading = function() {

	var self = this;

	this.loadStartTime = new Date().getTime() / 1000;

	// close our dropdown filters
	self.closeAllDropdownFilters();

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// if we're scrolled down, scroll the user back to the top of the results
	if ($(document).scrollTop() > self.options.$el.offset().top) {
		gsap.to(window, {duration: 0.8, scrollTo: self.options.$el.offset().top});
	}



	gsap.timeline({

	})
	.set(self.$filtersLoader, {
		display: 'block'
	})
	.to(self.$filtersLoader, {
		opacity: 1
	})
	.to(self.$resultsContainer, {
		duration: 0.15,
		opacity: 0
	}, 0)
	.set(self.$resultsContainer, {
		display: 'none'
	})
	.to(self.$noResultsContainer, {
		duration: 0.15,
		opacity: 0
	}, 0)
	.set(self.$noResultsContainer, {
		display: 'none'
	})
	.to(self.$paginationWrapper, {
		duration: 0.15,
		opacity: 0
	}, 0)
	.set(self.$paginationWrapper, {
		display: 'none'
	})
	.set(self.$placeholdersContainer, {
		display: 'flex'
	}, 0.15)
	.to(self.$heightAdjustWrapper, {
		duration: 0.2,
		height: "auto"
	}, ">-0.05")
	.fromTo(self.$placeholdersContainer,
		{
			opacity: 0
		},
		{
			duration: 0.35,
			opacity: 1
		}
		, ">-0.05"
	);

	// .to(self.$placeholdersContainer, {
	// 	duration: 0.3,
	// 	opacity: 1
	// }, ">-0.05");

};

DirectoryTwo.prototype.doneLoading = function(data) {

	var self = this;

	var pageInfo = data.pageInfo;
	var peopleData = data.people;

	var currTime = new Date().getTime() / 1000;

	if ((currTime - this.loadStartTime) < 0.8)
	{

		setTimeout(function() { self.doneLoading(data); }, 250);
		return;
	}

	// if no results were found
	if (peopleData.length < 1) {
		self.noResults();
		return;
	}

	// update our dom elements
	this.updatePeopleResultsDom(peopleData);
	this.updatePaginationDom(pageInfo.currentPage, pageInfo.totalPages);

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	var doneLoadingTimeline = gsap.timeline({

	})
	
	.to(self.$filtersLoader, {
		duration: 0.5,
		opacity: 0
	})
	.set(self.$filtersLoader, {
		display: 'none'
	})
	.to(self.$placeholdersContainer, {
		duration: 0.5,
		opacity: 0
	}, 0)
	.set(self.$placeholdersContainer, {
		display: 'none'
	})
	.set(self.$resultsContainer, {
		display: 'flex',
		opacity: 1
	});

	if (pageInfo.totalPages > 1) {

		doneLoadingTimeline
		.set(self.$paginationWrapper, {
			display: 'flex'
		});

	}
	else {

		doneLoadingTimeline
		.set(self.$paginationWrapper, {
			display: 'none'
		});

	}

	doneLoadingTimeline
	.to(self.$heightAdjustWrapper, {
		duration: 0.2,
		height: "auto"
	});

	

	doneLoadingTimeline
	.fromTo(self.$resultsContainer.find(`.${self.options.baseClass}__resultWrapper`),
		{
			opacity: 0,
			scale: 0.92
		},
		{
			duration: 0.4,
			opacity: 1,
			scale: 1,
			stagger: {
				each: 0.08
			}
		}
	);

	if (pageInfo.totalPages > 1) {

		doneLoadingTimeline
		.fromTo(self.$paginationWrapper,
			{
				opacity: 0
			},
			{
				opacity: 1
			}, "<"
		);

	}

};

DirectoryTwo.prototype.updatePaginationDom = function(currentPage, totalPages) {

	var self = this;

	this.$paginationWrapper.removeClass(`${self.options.baseClass}__pagination--hidden`);
	if (totalPages == 1) {
		this.$paginationWrapper.addClass(`${self.options.baseClass}__pagination--hidden`);
		return;
	}

	currentPage = parseInt(currentPage);
	totalPages = parseInt(totalPages);

	this.$paginationWrapper.empty();

	if (currentPage != 1) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage-1}" class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--previous">Prev</div>`
		);
	}

	if (currentPage > 1) {
		this.$paginationWrapper.append(
			`<div data-page="1" class="${self.options.baseClass}__pagination__link">1</div>`
		);
	}

	if (currentPage == 3) {
		this.$paginationWrapper.append(
			`<div data-page="2" class="${self.options.baseClass}__pagination__link">2</div>`
		);
	}

	if (currentPage == 4) {
		this.$paginationWrapper.append(
			`<div data-page="2" class="${self.options.baseClass}__pagination__link">2</div>
			<div data-page="3" class="${self.options.baseClass}__pagination__link">3</div>`
		);
	}

	if (currentPage > 4) {
		this.$paginationWrapper.append(
			`<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--separator">...</div>
			<div data-page="${currentPage-2}" class="${self.options.baseClass}__pagination__link">${currentPage-2}</div>
			<div data-page="${currentPage-1}" class="${self.options.baseClass}__pagination__link">${currentPage-1}</div>`
		);
	}

	this.$paginationWrapper.append(
		`<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--current">${currentPage}</div>`
	);

	if (totalPages - currentPage > 3) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link">${currentPage+1}</div>
			<div data-page="${currentPage+2}" class="${self.options.baseClass}__pagination__link">${currentPage+2}</div>
			<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--separator">...</div>`
		);
	}

	if (totalPages - currentPage == 3) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link">${currentPage+1}</div>
			<div data-page="${currentPage+2}" class="${self.options.baseClass}__pagination__link">${currentPage+2}</div>`
		);
	}

	if (totalPages - currentPage == 2) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link">${currentPage+1}</div>`
		);
	}

	if (totalPages - currentPage > 0) {
		this.$paginationWrapper.append(
			`<div data-page="${totalPages}" class="${self.options.baseClass}__pagination__link">${totalPages}</div>`
		);
	}

	if (currentPage != totalPages) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--next">Next</div>`
		);
	}

};

DirectoryTwo.prototype.updatePeopleResultsDom = function(peopleData) {

	var self = this;

	this.$resultsContainer.empty();

	for (let i = 0; i < peopleData.length; i++) {
		
		let $personDomElement = self.getPersonDomElement(peopleData[i]);
		
		this.$resultsContainer.append($personDomElement);

	}

};

DirectoryTwo.prototype.noResults = function(personData) {

	var self = this;

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	var noResultsTimeline = gsap.timeline({

	})
	
	.to(self.$filtersLoader, {
		duration: 0.5,
		opacity: 0
	})
	.set(self.$filtersLoader, {
		display: 'none'
	})
	.to(self.$placeholdersContainer, {
		duration: 0.5,
		opacity: 0
	}, 0)
	.set(self.$placeholdersContainer, {
		display: 'none'
	})
	.set(self.$noResultsContainer, {
		display: 'flex'
	})
	.set(self.$paginationWrapper, {
		display: 'none'
	})
	.to(self.$heightAdjustWrapper, {
		duration: 0.2,
		height: "auto"
	})
	.to(self.$noResultsContainer,
		{
			duration: 0.4,
			opacity: 1
		}
	);

};

DirectoryTwo.prototype.getPersonDomElement = function(personData) {

	var self = this;

	var $personDomElement = this.$personResultTemplate.clone()
		.removeClass(`${self.options.baseClass}__resultWrapper--resultTemplate`);

	// image
	$personDomElement.find(`.${self.options.baseClass}__person__imageLink`).attr('href', personData.url);
	if (personData.headshot.length > 0) {
		$personDomElement.find(`.${self.options.baseClass}__person__imageLink__image`).css('background-image', 'url('+personData.headshot[0].url+')');
	}

	$personDomElement.find(`.${self.options.baseClass}__person__info__name`).text(personData.title).attr('href', personData.url);
	
	if (personData.position) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__jobTitle`).text(personData.position);
	}
	else {
		$personDomElement.find(`.${self.options.baseClass}__person__info__jobTitle`).remove();
	}

	if (personData.city_state) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__location`).text(personData.city_state);
	}
	else {
		$personDomElement.find(`.${self.options.baseClass}__person__info__location`).remove();
	}

	if (!personData.phone_numbers.length > 0 && !personData.email) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo`).remove();
	}
	else {
		
		if (personData.phone_numbers.length > 0) {

			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__phone`).empty();

			var phoneNumbersString = '';

			for (let i = 0; i < personData.phone_numbers.length; i++) {
				let phoneNumber = personData.phone_numbers[i].number;
				let phoneNumberType = personData.phone_numbers[i].label[0].toUpperCase() + personData.phone_numbers[i].label.substring(1);

				if (phoneNumberType == 'Work') {
					phoneNumbersString += 'Office: ' + phoneNumber;
				}
				else {
					phoneNumbersString += phoneNumberType + ': ' + phoneNumber;
				}

				if (i != personData.phone_numbers.length - 1) {
					phoneNumbersString += '<br>';
				}

			}

			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__phone`).empty().append($.parseHTML(phoneNumbersString));
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__phone`).remove();
		}

		if (personData.email) {
			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__email`).text(personData.email);
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__email`).remove();
		}

	}

	if (!personData.linkedin && !personData.vcard) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__links`).remove();
	}
	else {

		if (personData.vcard) {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--vcard`).attr('href', personData.vcard);
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--vcard`).remove();
		}

		if (personData.linkedin) {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--linkedin`).attr('href', personData.linkedin);
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--linkedin`).remove();
		}

	}

	

	return $personDomElement;

};

export default DirectoryTwo;
